/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: f7c9ee0efde58a344baff1967cc92df3b2d9e9d93f049f380ed66d2a7c3779fb
 */
import cn from 'classnames'
import React, { ComponentProps, ReactElement } from 'react'

import Overlay from '../Overlay/Overlay'
import style from './Dropdown.style'

export const DropdownCompositionDependencies = ['Overlay'] as const

type DropdownOwnProps = {
  className?: string
  children?: React.ReactNode
  emptyDescription?: React.ReactNode
  emptyTitle?: string
  footer?: React.ReactNode
  header?: React.ReactNode
  isFooterAbsolute?: boolean
  search?: React.ReactNode
  state?: 'default' | 'empty'
}

export type DropdownProps = DropdownOwnProps & Omit<ComponentProps<'div'>, keyof DropdownOwnProps>

function Dropdown(props: DropdownProps): ReactElement {
  const {
    children,
    className = '',
    emptyDescription,
    emptyTitle = 'No matching results',
    footer,
    header,
    isFooterAbsolute = true,
    search,
    state = 'default',
    ...rest
  } = props

  return (
    <Overlay
      className={cn('Dropdown', className, { isFooterAbsolute, 'not-isFooterAbsolute': !isFooterAbsolute })}
      css={style}
      padding='none'
      {...rest}
      role={rest.role ?? 'menu'}
    >
      {header ? <div className='header'>{header}</div> : null}
      {search ? <div className='search'>{search}</div> : null}
      <div className='content'>
        {state === 'empty' ? (
          <div className='emptyState'>
            <p className='emptyTitle'>{emptyTitle}</p>
            {emptyDescription ? <p className='emptyDescription'>{emptyDescription}</p> : null}
          </div>
        ) : (
          children
        )}
      </div>
      {footer ? <div className='footer'>{footer}</div> : null}
    </Overlay>
  )
}

export default Dropdown
